import { Activity } from '@/features/activity/components/Activity'
import { Page } from '@/ui-kit'

export const ActivityPage = () => (
  <Page>
    <Activity />
  </Page>
)

export default ActivityPage
